/**
 * ч.937 (рішення власника): картка «Звʼязані документи» для ДОГОВОРУ —
 * УСІ документи, що посилаються на договір (не ланцюг BASE/CHILD, як у
 * документів): рахунки, реалізації, надходження, акти, ПН, платіжки тощо.
 * 3 свіжі у правій колонці + попап з повним переліком і сумами.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  relatedDocName, relatedDocRoute, useContractDocs,
} from '@/shared/components/RelatedDocs';
import TchTable from '@/shared/components/TchTable';

const fmtD = (v: string | null) => (v ? new Date(v).toLocaleDateString('uk-UA') : '—');
const fmtSum = (v: string | null | undefined) =>
  v == null ? '' : Number(v).toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ContractDocsCard({ contractId }: { contractId?: string }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const q = useContractDocs(contractId);
  const items = q.data ?? [];
  if (!contractId) {
    return (
      <div className="docrail__card" data-testid="contract-docs-card">
        <div className="docrail__title">Звʼязані документи</div>
        <div style={{ color: 'var(--muted)', fontSize: '0.8rem' }}>
          Зʼявляться після збереження договору.
        </div>
      </div>
    );
  }
  return (
    <div className="docrail__card" data-testid="contract-docs-card">
      <div className="docrail__title">
        Звʼязані документи
        {items.length > 0 && <small>{items.length}</small>}
      </div>
      {q.isLoading && <div style={{ color: 'var(--muted)', fontSize: '0.8rem' }}>Завантаження…</div>}
      {!q.isLoading && items.length === 0 && (
        <div style={{ color: 'var(--muted)', fontSize: '0.8rem' }}>
          За цим договором документів немає.
        </div>
      )}
      {items.slice(0, 3).map((r) => {
        const route = relatedDocRoute(r);
        return (
          <div key={`${r.document_type}:${r.document_id}`} className="docrail__row">
            <button type="button" className="docrail__link" style={{ padding: 0 }}
              disabled={!route} onClick={() => route && navigate(route)}>
              <span style={{ flex: 1 }}>{relatedDocName(r)} № {r.number ?? '—'}</span>
            </button>
            <div style={{ color: 'var(--muted)' }}>
              {fmtD(r.date)}{r.posted === false ? ' · чернетка' : ''}
            </div>
          </div>
        );
      })}
      {items.length > 3 && (
        <button type="button" className="docrail__more" onClick={() => setOpen(true)}>
          ще ({items.length - 3}) →
        </button>
      )}
      {open && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1100, background: 'var(--overlay)',
          display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setOpen(false)}>
          <div className="card" style={{ width: 760, maxHeight: '75vh', overflowY: 'auto', margin: 0 }}
            onClick={(e) => e.stopPropagation()}>
            <div className="toolbar" style={{ marginBottom: '0.5rem' }}>
              <h3 style={{ margin: 0 }}>Документи за договором</h3>
              <button style={{ marginLeft: 'auto' }} onClick={() => setOpen(false)}>закрити</button>
            </div>
            <TchTable>
              <thead>
                <tr>
                  <th>Документ</th><th>№</th><th>Дата</th>
                  <th style={{ textAlign: 'right' }}>Сума</th>
                  <th style={{ textAlign: 'center' }}>Проведено</th>
                </tr>
              </thead>
              <tbody>
                {items.map((r) => {
                  const route = relatedDocRoute(r);
                  return (
                    <tr key={`${r.document_type}:${r.document_id}`}
                      style={route ? { cursor: 'pointer' } : undefined}
                      onClick={() => route && navigate(route)}>
                      <td>{route
                        ? <span style={{ color: 'var(--primary)' }}>{relatedDocName(r)}</span>
                        : relatedDocName(r)}</td>
                      <td>{r.number ?? '—'}</td>
                      <td>{fmtD(r.date)}</td>
                      <td style={{ textAlign: 'right' }}>{fmtSum(r.amount)}</td>
                      <td style={{ textAlign: 'center' }}>
                        {r.posted == null ? '' : r.posted ? '✓' : '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </TchTable>
          </div>
        </div>
      )}
    </div>
  );
}
